import GoogleAnalytics from 'react-ga';

const hostName = '//lifetime.webcdn.network'

const settings = {

	SITENAME : 'It\'s A Wonderful Lifetime | Lifetime Movies',
	GA_ID : ' UA-126051290-3', // Analytics ID
	MANIFEST : [ // Preload these before the site runs
	  {
	    name:'navigation',
	    src:hostName+'/json/structures.json'
	  },
	  {
	    name:'entries',
	    src:hostName+'/json/entries.json'
	  },
	  {
	    name:'assets',
	    src:hostName+'/json/assets.json'
	  },
	  {
	    name:'globals',
	    src: hostName + '/json/globals.json'
	  }
	]

}



/*
	Init GA - off
*/

/*GoogleAnalytics.initialize({

    trackingId: settings.GA_ID,
    debug: true

});*/

export default settings;





// WEBPACK FOOTER //
// ./src/js/_settings.js